import { render, staticRenderFns } from "./custom-dialog.vue?vue&type=template&id=53f1f78c&scoped=true&"
import script from "./custom-dialog.vue?vue&type=script&lang=js&"
export * from "./custom-dialog.vue?vue&type=script&lang=js&"
import style0 from "./custom-dialog.vue?vue&type=style&index=0&id=53f1f78c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1f78c",
  null
  
)

export default component.exports